/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PasswordField from 'components/global/PasswordField';
import Button from '@mui/material/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { useForm, Controller } from 'react-hook-form';
import { resetPassword } from '../../actions/auths';
import { fetchUser } from '../../actions/user';

const ResetPassword = ({
  authenticated = false,
  match,
  history,
  resetPassword,
  fetchUser,
}) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm();
  const [errorMessage, setErrorMessage] = useState(false);
  const { formatMessage } = useIntl();

  const password = watch('password');

  // Redirect if already authenticated
  useEffect(() => {
    if (authenticated) {
      fetchUser(() => {
        history.push('/dashboard');
      });
    }
  }, [authenticated, fetchUser, history]);

  const onSubmit = async values => {
    setErrorMessage(false);
    const payload = {
      ...values,
      reset_password_token: match.params.token,
    };

    resetPassword(payload, (_response, error) => {
      if (error) {
        let msg = 'Error!';
        if (error.response?.data?.message) {
          msg = error.response.data.message;
        }
        setErrorMessage(msg);
      } else {
        history.push('/dashboard');
        window.location.reload();
      }
    });
  };

  return (
    <div className="signin-container">
      <div className="row">
        <div className="col">
          <div className="auth-form">
            <FormattedMessage tagName="h4" defaultMessage="Reset Password" />
            <form onSubmit={handleSubmit(onSubmit)}>
              <div>
                {/* New Password */}
                <Controller
                  name="password"
                  control={control}
                  rules={{
                    required: formatMessage({ defaultMessage: 'Required' }),
                    minLength: {
                      value: 8,
                      message: formatMessage({
                        defaultMessage:
                          'Password must be at least 8 characters',
                      }),
                    },
                  }}
                  render={({ field }) => (
                    <div className="input-row" style={{ marginTop: 20 }}>
                      <PasswordField
                        {...field}
                        label={formatMessage({
                          defaultMessage: 'New Password',
                        })}
                        helperText={errors.password?.message}
                        error={!!errors.password}
                      />
                    </div>
                  )}
                />

                {/* Password Confirmation */}
                <Controller
                  name="password_confirmation"
                  control={control}
                  rules={{
                    required: formatMessage({ defaultMessage: 'Required' }),
                    validate: value =>
                      value === password ||
                      formatMessage({
                        defaultMessage: 'Passwords do not match',
                      }),
                  }}
                  render={({ field }) => (
                    <div className="input-row" style={{ marginTop: 20 }}>
                      <PasswordField
                        {...field}
                        label={formatMessage({
                          defaultMessage: 'Password Confirmation',
                        })}
                        helperText={errors.password_confirmation?.message}
                        error={!!errors.password_confirmation}
                      />
                    </div>
                  )}
                />
              </div>

              <Button
                style={{ marginTop: '20px' }}
                className="flat-button-green"
                primary
                type="submit"
                disabled={isSubmitting}
              >
                {formatMessage({ defaultMessage: 'Reset Password' })}
              </Button>
            </form>

            {errorMessage && (
              <p style={{ color: '#f44336', marginTop: 20 }}>
                <b>{errorMessage}</b>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

ResetPassword.propTypes = {
  authenticated: PropTypes.bool,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
  fetchUser: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
  };
}

export default connect(mapStateToProps, { fetchUser, resetPassword })(
  ResetPassword,
);
